import { AERIALS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core/api';
import { handleQueryLifecycle } from '../utils';

export const DELETE_AERIAL_URL = 'aerial/delete';

export interface DeleteAerialRequest {
  aerialId: string;
}

/** `AerialDeleteResponse` carries no fields — success is signalled by the 200 alone. */
export type DeleteAerialResponse = Record<string, never>;

const deleteAerialApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteAerial: builder.mutation<DeleteAerialResponse, DeleteAerialRequest>({
      query: ({ aerialId }) => ({
        url: DELETE_AERIAL_URL,
        method: 'POST',
        body: {
          aerialId,
        },
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, () => {
          dispatch(api.util.invalidateTags([AERIALS_LIST_TAG]));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useDeleteAerialMutation } = deleteAerialApi;
